import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableMonth from '@/components/datatable/DataTableMonth.vue';
import HolidayPayObligationsTableActions from '@/components/holiday-pay-obligations/HolidayPayObligationsTableActions.vue';
import UploadHolidayPayObligations from '@/components/holiday-pay-obligations/UploadHolidayPayObligations.vue';
import type { HolidayPayObligation } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<HolidayPayObligation>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'payroll.year',
        id: 'year',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.headers.year',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'payroll.month',
        id: 'month',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.headers.month',
            }),
        cell: ({ row }) => {
            return h(DataTableMonth, {
                month: row.original.payroll.month,
            });
        },
        filterFn: 'valueInArray',
        meta: {
            filterType: 'month',
        },
    },
    {
        accessorKey: 'entries_count',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.headers.num_of_employees',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'file_upload',
        enableColumnFilter: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.headers.file_actions',
            }),
        cell: ({ row }) => {
            return h(UploadHolidayPayObligations, {
                holidayPayObligation: row.original,
            });
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(HolidayPayObligationsTableActions, {
                holidayPayObligation: row.original,
            });
        },
    },
];
